const momenttimethai = (data) => {
  var moment = require('moment')
  return (moment(data).tz('Asia/Bangkok').lang('th').format('LT'))
}
const momentdatethai = (data) => {
  var moment = require('moment')
  return moment(data).tz('Asia/Bangkok').lang('th').format('ll')
}

const momentdateen = (data) => {
  var moment = require('moment')
  return moment(data).tz('Pacific/Kiritimati').lang('en').format('ll')
}

const momenttimethaiformnow = (data) => {
  var moment = require('moment')
  return moment(moment(data).tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD h:mm:ss').lang('th').fromNow()
}

const momenttimethaiformnowen = (data) => {
  var moment = require('moment')
  return moment(moment(data).tz('Pacific/Kiritimati').format().replace(/T/g, ' '), 'YYYY-MM-DD h:mm:ss').fromNow()
}


const momenttimestamp = () => {
  var moment = require('moment')
  return ((moment().tz('America/Danmarkshavn').format()).replace(/T/g, ' ')).replace('Z', '')
}

const momentdatetimethai = (data) => {
  var moment = require('moment')
  return moment(data).tz('Pacific/Kiritimati').lang('th').format('llll').split('เวลา')[0]
}
export default {
  momenttimethai,
  momentdatethai,
  momenttimethaiformnow,
  momenttimethaiformnowen,
  momenttimestamp,
  momentdatetimethai,
  momentdateen
}



// WEBPACK FOOTER //
// ./src/services/momentthai.js